module.exports = __webpack_public_path__ + "static/media/diogo.5aebf2da.jpg";